module.exports = __webpack_public_path__ + "static/media/google-play-badge-en.442381aa.svg";